import PmaxCampaignWizard from '@/components/google-ads/performance-max/PmaxCampaignWizard';
import { SALES_OBJECTIVE } from './salesObjective';

/** NEW SALES (PERFORMANCE MAX) CAMPAIGN — /google-ads/sales/create/campaign */
export default function SalesCampaignWizard() {
  return <PmaxCampaignWizard objective={SALES_OBJECTIVE} />;
}
